// extracted by mini-css-extract-plugin
export default {"cls1":"YXh134aFgGZ4Hb_qby9I","cls2":"CLCNOf6B67aABEXDRwLs YXh134aFgGZ4Hb_qby9I","modal-slide-in":"jc9arpFU9H3E6Y9KiWrE","isPhone":"ckZ92HmToopxRp_7uxmd"};